<template>
  <section>
    <nav class="level">
      <div class="level-left"></div>
      <div class="level-right">
        <p class="level-item">
          <a class="button is-primary" @click="onAdd">
            <b-icon icon="plus"></b-icon>
            <span>{{ $t('attributes.add') + $t('attributes.voyage') }}</span>
          </a>
        </p>
      </div>
    </nav>
    <b-table
      :data="voyages"
      :loading="loading"
      :mobile-cards="false"
      narrowed
      bordered
    >
      <b-table-column
        field="sort"
        :label="$t('attributes.sort')"
        centered
        v-slot="props"
      >
        {{ props.row.sort }}
      </b-table-column>
      <b-table-column
        field="week"
        :label="$t('attributes.week')"
        centered
        v-slot="props"
      >
        {{ props.row.week }}
      </b-table-column>
      <b-table-column
        field="direction"
        :label="$t('attributes.direction')"
        centered
        v-slot="props"
      >
        {{ props.row.direction }}
      </b-table-column>
      <b-table-column
        field="arrive_time"
        :label="$t('attributes.arrive_time')"
        centered
        v-slot="props"
      >
        {{ props.row.arrive_time }}
      </b-table-column>
      <b-table-column
        field="checkin_time"
        :label="$t('attributes.checkin_time')"
        centered
        v-slot="props"
      >
        {{ props.row.checkin_time }}
      </b-table-column>
      <b-table-column
        field="gate_close_time"
        :label="$t('attributes.gate_close_time')"
        centered
        v-slot="props"
      >
        {{ props.row.gate_close_time }}
      </b-table-column>
      <b-table-column
        field="departure_time"
        :label="$t('attributes.departure_time')"
        centered
        v-slot="props"
      >
        {{ props.row.departure_time }}
      </b-table-column>
      <b-table-column :width="200" label="功能" centered v-slot="props">
        <b-button
          disabled="disabled"
          type="is-info"
          @click.prevent="onModify(props.row)"
        >
          {{ $t('attributes.modify') }}
        </b-button>
        <b-button
          disabled="disabled"
          type="is-danger"
          @click.prevent="onDelete(props.row)"
          style="margin-left:20px;"
          :loading="deleteSending"
        >
          {{ $t('attributes.delete') }}
        </b-button>
      </b-table-column>
    </b-table>

    <b-modal :active.sync="isModalActive" has-modal-card>
      <voyage-form
        disabled="disabled"
        :detail="selectedVoyage"
        :isCreate="isCreate"
        :productName="travelGroup.name"
        :sending="sending"
        @onSend="onSend"
      ></voyage-form>
    </b-modal>
  </section>
</template>

<script>
import { TRAVEL_GROUPS_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'
import VoyageForm from '@/components/travel_groups/VoyageForm'

export default {
  name: 'VoyageList',
  components: { VoyageForm },
  props: {
    travelGroup: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      loading: false,
      sending: false,
      deleteSending: false,
      code: this.travelGroup.code,
      voyages: [],

      isCreate: false,
      isModalActive: false,
      selectedVoyage: null
    }
  },
  watch: {
    travelGroup(newTravelGroup) {
      this.code = newTravelGroup.group_code
      this.isFormModalActive = false
      this.selectedTransfer = null
      this.loadVoyageAsync(newTravelGroup.code)
    }
  },
  mounted() {
    this.loadVoyageAsync(this.code)
  },
  methods: {
    async loadVoyageAsync(code) {
      const api = `${TRAVEL_GROUPS_API}/${code}/voyages`
      try {
        this.loading = true
        const res = await this.axios.get(api)
        this.voyages = res.data.data
      } catch (e) {
        this.voyages = []

        notifyService.fetch_error('voyage', e)
      } finally {
        this.loading = false
      }
    },
    async onAdd() {
      this.isCreate = true
      this.selectedVoyage = {
        id: '',
        group_code: this.code,
        week: '',
        direction: '',
        arrive_time: '',
        departure_time: '',
        checkin_time: '',
        gate_close_time: '',
        area_code: this.travelGroup.area_code,
        sort: 1
      }
      this.isModalActive = true
    },
    async onModify(item) {
      this.isCreate = false
      this.selectedVoyage = item
      this.isModalActive = true
    },
    async onDelete(item) {
      this.$buefy.dialog.confirm({
        message: '確定刪除此筆航程資料?',
        title: '警告',
        type: 'is-danger',
        hasIcon: true,
        confirmText: '確定',
        onConfirm: async () => {
          this.deleteSending = true
          const api = `${TRAVEL_GROUPS_API}/delete/voyage/${item.id}`
          try {
            await this.axios.delete(api)
            notifyService.success(this.$t('attributes.delete_succeed'))

            await this.loadVoyageAsync(this.code)
          } catch (e) {
            notifyService.delete_error(e)
          } finally {
            this.deleteSending = false
          }
        }
      })
    },
    onSend(item) {
      if (this.isCreate) {
        this.onCreate(item)
      } else {
        this.onUpdate(item)
      }
    },
    async onCreate(item) {
      try {
        const api = `${TRAVEL_GROUPS_API}/create/voyage`
        this.sending = true
        await this.axios.post(api, item)

        notifyService.success(this.$t('attributes.add_succeed'))
        await this.loadVoyageAsync(this.code)
      } catch (e) {
        notifyService.create_error(e)
      } finally {
        this.sending = false
      }
    },
    async onUpdate(item) {
      try {
        const api = `${TRAVEL_GROUPS_API}/update/voyage`
        this.sending = true
        await this.axios.put(api, item)

        notifyService.success(this.$t('attributes.update_succeed'))
        await this.loadVoyageAsync(this.code)
      } catch (e) {
        notifyService.update_error(e)
      } finally {
        this.sending = false
      }
    }
  }
}
</script>
